import { render } from "./UiStatus.vue?vue&type=template&id=4dc29778&scoped=true"
import script from "./UiStatus.vue?vue&type=script&lang=js"
export * from "./UiStatus.vue?vue&type=script&lang=js"

import "./UiStatus.vue?vue&type=style&index=0&id=4dc29778&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc29778"]])

export default __exports__